import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/c83a2ac2-17cd-4a8f-8607-22d85634507e";
export const REGISTER_URL = "https://a.ntrk2.com/efa8f245-5e0e-4297-ac46-f42326daec87";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://bigpe.kzw2a.com/download?openExternalBrowser=1&id=foqlycd69v7kzus";

export * from "./codes";
export * from "./context";
